import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-XBNXVVKVPN';

let initialized = false;

/**
 * Track a Facebook Pixel PageView event
 */
const trackFbPageView = () => {
  try {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'PageView');
    }
  } catch (e) {
    // Silently fail if fbq is not available
  }
};

/**
 * Track a custom Facebook Pixel event with optional parameters
 */
export const trackFbEvent = (eventName: string, params?: Record<string, any>) => {
  try {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', eventName, params);
    }
  } catch (e) {
    // Silently fail if fbq is not available
  }
};

export const initGA = () => {
  if (!initialized) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    initialized = true;
    console.log('[Analytics] GA4 initialized');
  }
};

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Send Google Analytics pageview on route change
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });

    // Send Facebook Pixel PageView on route change
    trackFbPageView();
  }, [location]);
};

// For manual GA event tracking anywhere in the app
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
